module.exports = __webpack_public_path__ + "img/weddings_33_V.81100b98.webp";